import { t } from "@/i18n-js/instance";
import { DefaultFullPreview } from "../../..";
import type { ComponentLineProps } from "../types";
import { shouldExpandFirstPayment } from "../variants/helpers";

export const EndingBalanceLine = ({ preview, options }: ComponentLineProps) => {
  if (
    !shouldExpandFirstPayment(preview) ||
    preview.first_payment.ending_balance >= 0
  ) {
    return null;
  }

  return (
    <DefaultFullPreview.PreviewEntry
      label={t("paywall_checkout.first_payment.ending_balance")}
      tooltip={t("paywall_checkout.first_payment.ending_balance_tooltip")}
      value={preview.first_payment.formatted_ending_balance}
      valueColor="text-green-600"
      dataTestId="checkout-form-preview-carry-over"
      {...options}
    />
  );
};
